export default __webpack_public_path__ + "static/media/Asset 22.b2b6b461.png";